import React, { useEffect, useContext } from "react";
import { db } from "../../../../config/firebase_config";
import { ref, get } from "firebase/database";
import RestaurentModel from "../../../../models/Restaurent_model.js";
import Restaurent from "../../../../components/restaurent-componet/Restaurent.jsx";
import RestaurentContext from "../../../../context/rest_context";
import { StoreSkeleton } from ".././../../../components/skeletons/skeletons.jsx";

const RestList = ({ restID }) => {
  const { subStores, setSubStores } = useContext(RestaurentContext);

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const databaseRef = ref(db , `${restID}_SubStores` );
    //     const snapshot = await get(databaseRef);
    //     let restModelData = [];
    //     console.log(snapshot);
    //     if(snapshot.exists()){
    //       const data= snapshot.val();
    //       console.log(data);
    //       Object.entries(data).forEach(async([key,value] ) => {
    //         console.log(key)
    //         console.log(value)
    //         const storeRef = ref(db , `RestaurantMenu/${key}` );
    //         const storeSnap = await get(storeRef);
    //         const restVal =storeSnap.val();
    //         console.log(restVal);
    //         restModelData.push( RestaurentModel.fromJson( key, restVal) );
    //       } )
    //       console.log(restModelData )
    //       setSubStores(restModelData);
    //     }
    //   } catch (error) {
    //     console.error('Error fetching data:', error);
    //   }
    // };

    const fetchData = async () => {
      try {
        const databaseRef = ref(db, `${restID}_SubStores`);
        const snapshot = await get(databaseRef);
        console.log(snapshot, "rest ids ra ayya ...");
        let restModelData = [];
        if (snapshot.exists()) {
          const data = snapshot.val();
          console.log(data, "rest data ra ayya...");
          for (const [key, value] of Object.entries(data)) {
            console.log(key);
            const storeRef = ref(db, `RestaurantMenu/${key}`);
            const storeSnap = await get(storeRef);
            const restVal = storeSnap.val();
            console.log({ restVal, name: restVal?.name, status: restVal.status });
            if (restVal?.status == "Active") {
              restModelData.push(RestaurentModel.fromJson(key, restVal));
              console.log(
                "<---- status is  --->",
                `${restVal.status}`,
                "<---- status is  --->"
              );
            }
          }
          console.log({ restModelData });
          setSubStores(restModelData);
        } else {
          const storeRef = ref(db, `RestaurantMenu/${restID}`);
          const storeSnap = await get(storeRef);
          const restVal = storeSnap.val();
          if (restVal?.status == "Active") {
            restModelData.push(RestaurentModel.fromJson(restID, restVal));
            console.log(
              "<---- status is  --->",
              `${restVal.status}`,
              "<---- status is  --->"
            );
            setSubStores(restModelData);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (subStores.length == 0) {
      fetchData();
    }
  }, []);

  console.log({ restID })
  return subStores.length == 0 ? (
    <>
      <StoreSkeleton />
      <StoreSkeleton />
      <StoreSkeleton />
    </>
  ) : (
    <>
      {subStores.map((restItem, index) => {
        console.log(restItem, "each restaturent");
        return <Restaurent key={index} restItem={restItem} />;
      })}
    </>
  );
};

export default RestList;
